import { render, staticRenderFns } from "./InformedDeliverySignup.vue?vue&type=template&id=b6622db2&"
import script from "./InformedDeliverySignup.vue?vue&type=script&lang=js&"
export * from "./InformedDeliverySignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports